/**
 * Бренд снят платформой с витрины.
 *
 * Страницу при этом не прячем: на ней правила, список участников и результаты
 * розыгрышей — то, чем человек доказывает своё участие. Пропадает только
 * призыв участвовать, потому что код сервер всё равно не примет.
 */
import { Icon } from '@allswipes/ui';

import { useT } from '@allswipes/i18n';

export function SuspendedNote({ reason }: { reason?: string }) {
  const t = useT();
  return (
    <div className="susp">
      <Icon name="alert" size={15} />
      <div>
        <strong>{t('Акции этого бренда приостановлены платформой.')}</strong>{' '}
        {reason ? `${reason} ` : ''}
        {t('Новые коды не принимаются. Правила и результаты прошедших розыгрышей остаются здесь и проверяются как обычно.')}
      </div>
    </div>
  );
}
